export default "__VITE_ASSET__BtBNJILA__"